const QUESTION_OPEN = '<user_question>\n';
const QUESTION_CLOSE = '\n</user_question>';
const QUESTION_ESCAPE = '<\\/user_question>';

/**
 * The completions API stores one message string. Inbox document context rides
 * in that string, and the thread renders only the clinician's question.
 */
export function withHiddenContext(question: string, context: string): string {
  const safeQuestion = question.replaceAll('</user_question>', QUESTION_ESCAPE);
  return `${QUESTION_OPEN}${safeQuestion}${QUESTION_CLOSE}\n<hidden_context>\n${context}\n</hidden_context>`;
}

/** Question text when `content` was built with {@link withHiddenContext}. */
export function visibleChatContent(content: string): string {
  if (!content.startsWith(QUESTION_OPEN)) return content;
  const end = content.indexOf(QUESTION_CLOSE);
  if (end === -1) return content;
  return content
    .slice(QUESTION_OPEN.length, end)
    .replaceAll(QUESTION_ESCAPE, '</user_question>');
}
